<template>
  <div>
    <v-autocomplete
      :outlined="disableOutlined ? false : !disabled"
      :prepend-icon="prependIcon ? 'mdi-magnify' : ''"
      :filled="disabled"
      ref="autocomplete"
      v-model="value"
      :search-input.sync="query"
      :hide-details="'auto'"
      :label="label"
      :persistent-hint="hint !== ''"
      :hint="this.isTotalCenter ? this.labelMacCenter : hint"
      :disabled="disabled"
      :loading="loading"
      :items="items"
      :placeholder="params.placeholder || label"
      :item-text="itemText"
      :item-value="params.value || 'id'"
      :multiple="isMultiple"
      :no-filter="true"
      :clearable="!required"
      :no-data-text="messageEmpty"
      :rules="rules"
      :hide-no-data="!isEmpty"
      @click="showTextHelpClick()"
      @blur="showTextHelp()"
      @keydown="handleSearch($event)"
      @change="emitInputData"
    >
      <template v-if="$slots.required" v-slot:prepend-inner>
        <slot name="required"></slot>
      </template>

      <template v-slot:append-item>
        <div v-intersect="endIntersect" />
      </template>

      <template v-slot:no-data v-if="params.nodatamessage">
        <v-list-item>
          <v-list-item-title>
            {{params.nodatamessage}}
            <strong v-if="params.extraFilter">
              {{$t('components.search.noDataMessage')}}
              <v-icon
                size="20"
              >
                mdi-filter-plus-outline
              </v-icon>
              {{$t('components.search.noDataMessageContinue')}}
          </strong>
          </v-list-item-title>
        </v-list-item>
      </template>
      <template v-slot:append >
        <div v-if="!prependIcon">
          <v-icon v-if="!loading">mdi-magnify</v-icon>
          <v-progress-circular
            v-else
            color="primary"
            indeterminate
            size="25"
          >
          </v-progress-circular>
        </div>
      </template>

      <template v-slot:selection="data" v-if="isMultiple">
        <v-chip
          class="mt-2"
          v-bind="data.attrs"
          :input-value="data.selected"
          close
          @click="data.select"
          @click:close="remove(data.item)"
        >
          {{ itemText(data.item) }}
        </v-chip>
      </template>
      <template v-slot:append-outer
        v-if="params.extraFilter || (isMobile && isBarcodeScan)"
      >
        <v-btn
          icon
          color="primary"
          v-if="params.extraFilter"
          @click="openModal = !openModal"
        >
          <v-icon
            size="30"
            class="mb-4"
          >
            mdi-filter-plus-outline
          </v-icon>
        </v-btn>
        <ExtendedSearch
          v-if="openModal && params.extraFilter"
          :filtersSearch="evalParam(params.extraFilter)"
          :filters="evalParam(params.filters)"
          :params="params"
          :title="label"
          @close="openModal = false"
          @send="getResultExtendedSearch($event)"
        >
        </ExtendedSearch>
        <v-btn icon color="primary"
          @click="barCodeScannerClick()"
          v-if="isMobile && isBarcodeScan"
        >
          <v-icon size="30" class="mb-4">
            mdi-camera
          </v-icon>
        </v-btn>
      </template>
    </v-autocomplete>
    <span class="showHintP" v-if='this.showHintPrimary &&
    this.hintPrimary'>
     {{this.hintPrimary}}
    </span>
    <span v-if='isMobile && barCodeNotFound'>
      {{ $t('components.barCodeScanner.barCodeNotFound', [barCode]) }}
    </span>
  </div>
</template>

<script>

/**
 * expected params format:
 *
 * {
 *  target: <string> specifies service target [ 'backend', 'cges', 'CA' ],
 *  entity: <string> specifies service entity (I.E 'cnt', 'nr', ...),
 *  query: string|<function(object)> custom where clause (WC request field) which will be
 *                  sent into each search request
 *  match: <string> item keys splitted by ','
 *  fields: <string> requested fields splitted by ',' sent into each search request
 *  lookandfeel: <Function(item)> parse item expression to render each result row
 * }
 */
import axios from 'axios';
import Vue from 'vue';
import ExtendedSearch from '../special-types/ExtendedSearch.vue';

export default {
  props: {
    label: String,
    hint: String,
    placeholder: String,
    messageEmpty: String,
    disabled: Boolean,
    disableOutlined: Boolean,
    prependIcon: Boolean,
    rules: {
      type: Array,
      default: () => [],
    },
    initialValue: {
      required: false,
    },
    inputData: Object,
    params: {
      type: Object,
      default: () => ({}),
    },
    required: {
      type: Boolean,
      default: () => false,
    },
    specialValue: {
      type: Object,
      default: () => ({}),
    },
    cancelable: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    ExtendedSearch,
  },
  data() {
    return {
      defaultItem: null,
      query: null,
      value: null,
      keyPressed: false,
      loading: false,
      items: [],
      searchArguments: {},
      others: [],
      loadingAltiris: false,
      isEmpty: false,
      openModal: false,
      focusOut: false,
      isTotalCenter: false,
      labelMacCenter: 'El máximo de centros posible es 10',
      barCode: null,
      barCodeNotFound: false,
      showHintPrimary: false,
      isAuxSearch: false,
      first: 0,
      canPaginate: false,
      activeSearchRequest: null,
      refreshRequestSeq: 0,
    };
  },

  computed: {
    isMultiple() {
      return this.params.multiple === 'true';
    },
    globalContext() {
      return this.$parent.expressionInterpreter.ctx;
    },
    valueAttribute() {
      if (typeof this.params.value === 'function') {
        return (item) => this.params.value({
          item,
        });
      }
      return this.params.value || 'id';
    },
    valueAttributeItem() {
      // we could need the lookandfeel as value
      // to ensure the item will be the same we will check
      // the value aplying lookandfeel format in each item
      if (this.valueAttribute === 'value') {
        return this.itemText;
      }

      if (typeof this.params.value === 'function') {
        return (item) => this.params.value({ item });
      }

      const value = this.valueAttribute.split('.');
      return (item) => value.reduce((tot, curr) => tot[curr], item);
    },
    searchLength() {
      return this.params.minlength ? this.params.minlength : 3;
    },
    isMobile() {
      const getter = this.$store.getters['globalState/get'];
      return getter('deviceOS') != null;
    },
    isBarcodeScan() {
      return (this.params || {}).barcodeScan === 'true';
    },
  },

  watch: {
    query(val) {
      this.first = 0;

      if (val === this.lastSearch) {
        this.showTextHelp();
        return;
      }

      if (this.cancelable) {
        this.cancelActiveSearchRequest();
        this.loading = false;
      }
      if (this.params.multiple === 'true') {
        this.items = this.items.filter((item) => this.value.includes(item.name));
      } else if (val !== null) {
        this.items = [];
      }

      this.showTextHelp();
      this.$debounce(async (v) => {
        if (v && v.length >= this.searchLength && v === this.query && this.keyPressed) {
          this.keyPressed = false;
          if (this.cancelable || !this.loading) {
            this.refreshItems(v);
          }
        } else if (v === '') {
          this.items = this.value.length ? this.items : [];
        }
      }, this.params.timeSearch || 750)(val);
    },

    // this function watches the expressionInterpreter context
    // and will be called when this context had changed
    globalContext() {
      // the evalued interpreter params are apicges and filters
      // we supose an auto-update when, after eval old and new params,
      // those params are distinct
      const shouldUpdateComponent = ['apicges', 'filters']
        .filter((key) => this.params[key] && this.searchArguments[key])
        .map((key) => [key, this.evalParam(this.params[key], this.searchArguments.query)])
        .some((neweval) => {
          const newchanges = JSON.stringify(neweval[1]);
          const oldchanges = JSON.stringify(this.searchArguments[neweval[0]]);
          return newchanges !== oldchanges;
        });

      if (shouldUpdateComponent) {
        this.refreshItems(/* this.query || '' */);
        this.$forceUpdate();
      }
    },
    value(newVal) {
      if (newVal === '' || newVal === null) {
        this.items = [];
      }
      if (this.params.alias === 'CISearch') {
        this.$root.$emit('CISearch', {
          value: newVal,
          item: undefined,
          alias: this.params.alias,
        });
      }
    },
  },

  methods: {
    // Cancela la peticion de busqueda activa, si existe.
    cancelActiveSearchRequest() {
      if (this.activeSearchRequest != null && typeof this.activeSearchRequest.cancel === 'function') {
        this.activeSearchRequest.cancel();
      }
      this.activeSearchRequest = null;
    },

    async endIntersect() {
      if (this.isAuxSearch === true) {
        this.isAuxSearch = false;
        return;
      }

      this.first += 1;

      const {
        filters,
        apicges,
        target,
      } = this.params;

      let evaluedApicges = '';
      if (apicges) {
        evaluedApicges = this.evalParam(apicges);
        this.searchArguments.apicges = evaluedApicges;
      }
      const evaluedFilters = this.evalParam(filters, this.query);
      this.searchArguments.filters = JSON.parse(JSON.stringify(evaluedFilters));

      if (target === 'backend' && this.query && this.query.trim() !== '') {
        const matchCondition = this.matchToFilters(this.query);

        if (evaluedFilters.$or != null) {
          const { $or } = evaluedFilters;

          delete evaluedFilters.$or;
          evaluedFilters.$and = [
            { $or }, { $or: matchCondition },
          ];
        } else {
          evaluedFilters.$or = matchCondition;
        }
      }

      const result = await this.search({ apicges: evaluedApicges, filters: evaluedFilters });

      if (result.total > 0) {
        const totalListSearch = [...this.items, ...result.list];
        this.items = [...totalListSearch];
      }
    },
    showTextHelpClick() {
      this.isEmpty = false;
      this.isAuxSearch = true;
    },
    showTextHelp() {
      this.isAuxSearch = true;
      const { autocomplete } = this.$refs;
      if (!this.value && this.required && autocomplete?.validations?.length > 0) {
        this.showHintPrimary = true;
      } else {
        this.showHintPrimary = false;
      }
    },
    async search({ apicges, filters }) {
      let isPagination = false;
      if (this.first >= 1) {
        isPagination = true;
      }

      const startSeach = this.first.toString();
      this.loading = true;

      const user = this.$store.getters['session/user'];
      // const inputAlias = this.$parent.alias;

      const {
        // target, entity, fields, query, lookandfeel, match,
        target, entity, fields = 'id,name', querysize, order, noresultsrowid, isOrdenLocation,
      } = this.params;

      let priorityQuery = {};
      if (isOrdenLocation) {
        priorityQuery = {
          cityQuery: user.provinceUser.city,
          stateQuery: user.provinceUser.state,
          locationQuery: user?.location?.id,
        };
      }

      let result = null;
      try {
        result = await this.client.search({
          target,
          entity,
          fields,
          filters,
          order,
          apicges,
          size: querysize,
          first: startSeach,
          noresultsrowid,
          isPagination,
          priorityQuery,
        });
        this.loading = false;
        return result;
      } catch (ex) {
        console.error('error during search request', ex);
      }

      this.loading = false;
      return result;
    },
    getDelimiter(val) {
      return val.includes(',') ? ',' : ' ';
    },
    matchToFilters(queryValue) {
      const { match, zalias } = this.params;
      if (zalias && zalias === 'interesados') {
        const COMPONENT_MATCH_FIELDS = ['zdni', 'userid', 'first_name', 'middle_name', 'last_name'];

        if (queryValue.includes(',') || !queryValue.includes(' ')) {
          const query = queryValue.trim().replace(/ +/i, ' ').replace(/ /i, '%').toUpperCase();
          const delimiter = this.getDelimiter(queryValue);

          // if query value has some ','
          if (queryValue.includes(delimiter)) {
            const splitted = queryValue.split(delimiter);
            const numberOfOcurrences = (queryValue.match(new RegExp(delimiter, 'g')) || []).length;
            let keys;
            switch (numberOfOcurrences) {
            case 3:
              keys = ['middle_name', 'last_name', 'first_name', 'location.name'];
              break;
            case 2:
              keys = ['middle_name', 'last_name', 'first_name'];
              break;
            case 1:
            default:
              keys = ['middle_name', 'last_name'];
            }
            return [keys.reduce((acum, key, idx) => {
              acum[key] = { $regex: `%${splitted[idx].trim().toUpperCase()}%` }; // eslint-disable-line
              return acum;
            }, {})];
          }

          // get match param for extra matching fields
          const matchP = (typeof match === 'string' ? match.split(',') : [])
            .filter((field) => !COMPONENT_MATCH_FIELDS.includes(field))
            .concat(COMPONENT_MATCH_FIELDS);

          return matchP.map((param) => ({ [param]: { $regex: `%${query}%` } }));
        }

        const fullNameQuery = `%${queryValue.replace(/ /g, '%').toUpperCase()}%`;
        return {
          full_name_contact_search: { $regex: fullNameQuery },
        };
      }

      const query = queryValue.trim().replace(/ +/i, ' ').replace(/ /i, '%').toUpperCase();
      const matchP = typeof match === 'string' ? match.split(',') : ['name'];
      const matchCondition = matchP.map((param) => ({ [param]: { $regex: `%${query}%` } }));

      if (match === 'full_name_contact_search') {
        const fullNameQuery = `%${queryValue.replace(/ /g, '%').toUpperCase()}%`;
        return {
          full_name_contact_search: { $regex: fullNameQuery },
        };
      }
      return matchCondition;
    },

    async refreshItems(queryValue = '') {
      let currentRequestSeq = this.refreshRequestSeq;
      if (this.cancelable) {
        this.cancelActiveSearchRequest();
        this.refreshRequestSeq += 1;
        currentRequestSeq = this.refreshRequestSeq;
      }

      const {
        target, filters, apicges,
      } = this.params;
      /// updates the evalued params for auto-update detection
      const evaluedFilters = this.evalParam(filters, queryValue);
      this.searchArguments.filters = JSON.parse(JSON.stringify(evaluedFilters));

      // for 'backend' target we will use the 'match' zparams value
      // to extend the filters with user input
      if (target === 'backend' && queryValue.trim() !== '') {
        const matchCondition = this.matchToFilters(queryValue);

        // if filters already includes an $or key
        // we will extend this $or with match conditions
        if (evaluedFilters.$or != null) {
          const { $or } = evaluedFilters;

          delete evaluedFilters.$or;
          evaluedFilters.$and = [
            { $or }, { $or: matchCondition },
          ];
        } else {
          evaluedFilters.$or = matchCondition;
        }
      }
      /// input text (query) saving
      this.searchArguments.query = queryValue;

      let evaluedApicges;
      if (apicges) {
        evaluedApicges = this.evalParam(apicges);
        this.searchArguments.apicges = evaluedApicges;
      }

      let result = null;
      if (!this.cancelable) {
        result = await this.search({ apicges: evaluedApicges, filters: evaluedFilters });
      } else {
        this.loading = true;
        try {
          let priorityQuery = {};
          if (this.params.isOrdenLocation) {
            const user = this.$store.getters['session/user'];
            priorityQuery = {
              cityQuery: user.provinceUser.city,
              stateQuery: user.provinceUser.state,
              locationQuery: user?.location?.id,
            };
          }

          const request = this.client.cancelableSearch({
            target: this.params.target,
            entity: this.params.entity,
            fields: this.params.fields || 'id,name',
            filters: evaluedFilters,
            order: this.params.order,
            first: this.first.toString(),
            size: this.params.querysize,
            apicges: evaluedApicges,
            noresultsrowid: this.params.noresultsrowid,
            isPagination: this.first >= 1,
            priorityQuery,
          });

          this.activeSearchRequest = request;
          const response = await request;
          result = request.format(response);
        } catch (ex) {
          if (!axios.isCancel(ex)) {
            console.error('error during cancelable search request', ex);
          }
          return;
        } finally {
          if (currentRequestSeq === this.refreshRequestSeq) {
            this.activeSearchRequest = null;
            this.loading = false;
          }
        }
      }

      if (this.cancelable && currentRequestSeq !== this.refreshRequestSeq) {
        return;
      }

      // [FIX#1] close menu if opened before update items
      // if menu is active and we have fewer results than current items list
      // we force menu updating to ensure the position of the new menu items list
      const currMenuState = this.$refs.autocomplete.isMenuActive === true;
      if (currMenuState) {
        this.$refs.autocomplete.isMenuActive = false;
      }

      const copyItemsMultiple = this.items;
      this.items = (result || {}).list || [];

      // if multiple selection enabled
      // we need to add to new items result the current items list to
      // dont loose the current selection
      if (this.isMultiple) {
        this.items = copyItemsMultiple
          .filter((selected) => {
            const value = this.valueAttributeItem(selected);
            // return this.value.includes(value);
            return Array.isArray(this.value) && this.value.includes(value);
          })
          .concat(this.items);
      }

      // [FIX#1] reopen menu after items update
      if (currMenuState) {
        this.$refs.autocomplete.isMenuActive = true;
      }

      this.isEmpty = (this.items || []).length === 0 || (
        (this.items || []).length === 1 && this.items[0].id === (this.defaultItem || {}).id
      );
    },
    handleSearch(e) {
      if (e.keyCode === 13) {
        e.preventDefault();
      }
      this.showTextHelp();
      this.keyPressed = true;
    },

    itemText(item) {
      const { lookandfeel, lookandfeelType } = this.params;
      if (typeof lookandfeel === 'function') {
        return lookandfeel({ item, value: this.query });
      }

      if (item === null) {
        console.warn('trying to get item.name from null, check Search component');
        return null;
      }

      if (lookandfeelType === 'cnt') {
        return `${item.middle_name} ${item.last_name} ${item.first_name} (${item.location.name})`;
      }
      return item.name;
    },

    evalParam(param, v) {
      const str = typeof param === 'function' ? param({ value: v }) : param;
      try {
        return JSON.parse(str || '{}');
      } catch (ex) {
        return str;
      }
    },

    remove(item) {
      const valueAttributeItem = this.valueAttributeItem(item);
      const valueIndex = this.value.findIndex((ele) => ele === valueAttributeItem);

      // we assume this.value and this.items has same length and order
      if (valueIndex >= 0) {
        this.value.splice(valueIndex, 1);
      }

      const { length } = this.value.join(',');
      this.emitFormDisable(length);

      this.$emit('update:inputData', {
        value: this.value,
        item: null,
      });
    },

    emitInputData($evt) {
      let value = $evt;
      const item = this.items.find((itm) => this.valueAttributeItem(itm) === $evt);

      if (item) {
        this.lastSearch = this.itemText(item);
      }

      const { integrationid, integrationlabel, integrationname } = this.specialValue;
      const inputAlias = this.$parent.alias;

      if (this.params.maxLength) {
        if (value instanceof Array) {
          const { length } = value.join(',');
          this.emitFormDisable(length);
        }
      }
      if ((this.params.valueasobject === 'true' || (this.params?.value && this.params.value !== 'id'))
          && item !== null && item !== undefined) {
        const integrationidAux = item[integrationid];
        const integrationlabelAux = item.integrationlabel !== undefined
          ? item[integrationlabel]
          : integrationlabel;
        const integrationnameAux = item[integrationname];

        value = {
          value,
          id: item.id,
          integrationid: integrationidAux,
          integrationlabel: integrationlabelAux,
          integrationname: integrationnameAux,
        };
      }
      this.$emit('update:inputData', {
        value,
        item,
      });

      if (inputAlias === 'interesados' || inputAlias === 'requestedBy') {
        this.$root.$emit('contactSuscriptor', {
          value,
          item,
          alias: inputAlias,
        });
      }
    },

    emitFormDisable(length) {
      if (length > parseInt(this.params.maxLength, 10)) {
        this.isTotalCenter = true;
        this.$root.$emit('formDisabledBtn', this.isTotalCenter);
      } else {
        this.isTotalCenter = false;
        this.$root.$emit('formDisabledBtn', this.isTotalCenter);
      }
    },

    async getResultExtendedSearch($evt) {
      try {
        this.openModal = false;
        const inputAlias = this.$parent.alias;

        const { target, entity, fields } = this.params;
        const result = await this.client.search({
          target, entity, fields, filters: { id: $evt.id },
        });
        console.log('initial search result', result);
        const valueItem = result.unique();
        this.value = valueItem;
        this.defaultItem = valueItem;

        this.items = result.list;
        this.lastSearch = this.itemText(valueItem);

        // force update to emit item and value event to update context
        this.$emit('update:inputData', {
          value: this.valueAttributeItem(this.value),
          item: this.value,
        });

        if (inputAlias === 'interesados') {
          const value = $evt;
          // const item = this.items.find((itm) => this.valueAttributeItem(itm) === $evt);
          this.$root.$emit('contactSuscriptor', {
            value: value.id,
            item: value,
            alias: inputAlias,
          });
        }
        if (inputAlias === 'requestedBy') {
          const item = $evt;
          this.$root.$emit('contactSuscriptor', {
            value: item.id,
            item,
            alias: inputAlias,
          });
        }
      } catch (ex) {
        console.error('error in initialsearch', ex);
      }
    },

    async makeSearch(searchId) {
      this.client = this.$api.getClient('search');
      let result = null;

      const resultValue = /^\+?(0|[1-9]\d*)$/.test(searchId) ? parseInt(searchId, 10) : `${searchId}`;
      const { value, filters, apicges } = this.params;

      let evaluedApicges;
      if (apicges) {
        evaluedApicges = this.evalParam(apicges);
        this.searchArguments.apicges = evaluedApicges;
      }
      const initialValueProperty = this.params.initialvalueproperty || value || 'id';
      let evaluedFilters = {};
      if (initialValueProperty !== 'id') {
        evaluedFilters = this.evalParam(filters);
        this.searchArguments.filters = JSON.parse(JSON.stringify(evaluedFilters));
      }

      evaluedFilters[initialValueProperty] = resultValue;

      try {
        result = await this.search({ apicges: evaluedApicges, filters: evaluedFilters });
      } catch (ex) {
        console.error('error retrieving initial value search', ex);
      }

      if (result != null && result.total > 0) {
        const valueItem = result.unique();
        this.value = valueItem;
        this.defaultItem = valueItem;

        this.items = result.list;
        this.lastSearch = this.itemText(valueItem);

        // force update to emit item and value event to update context
        this.$emit('update:inputData', {
          value: this.valueAttributeItem(this.value),
          item: this.value,
        });
      }
    },

    barCodeScannerClick() {
      Vue.prototype.$flutterPort.postMessage('flutterOpenBarCodeScanner');
    },

    async searchFromFlutter(eventData) {
      try {
        if (!this.isBarcodeScan) {
          return;
        }
        if (typeof this.$parent.config.component === 'string'
          && this.$parent.config.component.toLowerCase() === 'altirissearch') {
          return;
        }
        if (this.barCode === eventData) {
          return;
        }
        console.log(`Flutter mensaje desde móvil: ${eventData}`);
        this.barCodeNotFound = false;
        this.barCode = eventData;
        await this.refreshItems(eventData);
        if (this.items.length === 0) {
          this.barCodeNotFound = true;
        } else {
          this.barCodeNotFound = false;
          const valueItem = this.items[0];
          this.value = valueItem;
          this.defaultItem = valueItem;
          this.lastSearch = this.itemText(valueItem);

          // force update to emit item and value event to update context
          this.$emit('update:inputData', {
            value: this.valueAttributeItem(this.value),
            item: this.value,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
  },

  async created() {
    this.client = this.$api.getClient('search');
    const { initialsearch } = this.params;
    let result = null;
    this.hintPrimary = this.hint;
    // if initial value provided we will make a search to select the default row
    if (this.initialValue) {
      const resultValue = /^\+?(0|[1-9]\d*)$/.test(this.initialValue) ? parseInt(this.initialValue, 10) : `${this.initialValue}`;
      const {
        value, filters, apicges,
      } = this.params;

      /// we need to save a copy of evalued request params to detect
      /// when the component needs to be auto-updated
      let evaluedApicges;
      if (apicges) {
        evaluedApicges = this.evalParam(apicges);
        this.searchArguments.apicges = evaluedApicges;
      }
      const initialValueProperty = this.params.initialvalueproperty || value || 'id';
      let evaluedFilters = {};
      if (initialValueProperty !== 'id') {
        evaluedFilters = this.evalParam(filters);
        this.searchArguments.filters = JSON.parse(JSON.stringify(evaluedFilters));
      }

      evaluedFilters[initialValueProperty] = resultValue;
      /// end

      // initial value search
      try {
        result = await this.search({ apicges: evaluedApicges, filters: evaluedFilters });
      } catch (ex) {
        console.error('error retrieving initial value search', ex);
      }

    // component could contain an initial search to suggest some options without input
    } else if (initialsearch != null) {
      const { entity, params, isExtendedSearch } = this.evalParam(initialsearch);
      // 1000118
      if (entity == null || params == null) {
        console.error('invalid initial search configuration: entity and params fields are mandatory');
        return;
      }

      try {
        if (isExtendedSearch) {
          const { target, fields, order } = this.evalParam(initialsearch);
          result = await this.client.search({ target, entity, fields, order, filters: params }); //   eslint-disable-line
        } else {
          result = await this.client.search({ target: 'namedquery', entity, filters: params });
        }
        console.log('initial search result', result);
      } catch (ex) {
        console.error('error in initialsearch', ex);
      }
    }

    if (result != null && result.total > 0) {
      const valueItem = result.unique();
      this.value = valueItem;
      this.defaultItem = valueItem;

      this.items = result.list;
      this.lastSearch = this.itemText(valueItem);

      // force update to emit item and value event to update context
      this.$emit('update:inputData', {
        value: this.valueAttributeItem(this.value),
        item: this.value,
      });
    }

    if (window.flutter_inappwebview && this.isBarcodeScan) {
      this.$root.$on('flutter:barcodeCapture', (event) => {
        console.log(`Flutter mensaje desde móvil: ${event}`);
        this.searchAltirisBarCode(event);
      }, false);
    }
  },

  beforeDestroy() {
    if (this.cancelable) {
      this.cancelActiveSearchRequest();
    }
    this.$emit('update:inputData', {});
  },
};
</script>

<style scoped>
.showHintP{
    font-size: 10.4px !important;
    color: rgba(0, 0, 0, 0.6);
    padding: 0 12px;
}
</style>
